<template>
    <div @click="selected($event)" class="dropdown-document-result">

        <div class="left">
            <div :class="{'no-thumbnail':!hasThumbnail}" class="result-thumbnail">
                <figure>
                    <img :src="thumbnail" alt="" loading="lazy">
                </figure>
            </div>
        </div>
        <div class="right">
            {{field('title')}}
            <p v-show="!!field('description')">{{field('description')}}</p>
        </div>


    </div>
</template>

<script>
    export default {
        name: "DropdownDocumentResult",
        data: function () {
            return {}
        },
        props: ['result', 'select', 'current'],
        methods: {
            field($name) {
                if (!this.displayResult)
                    return "";
                if (this.displayResult.fields[$name])
                    return ((this.displayResult.fields[$name].length > 1 ? this.displayResult.fields[$name].join(' ') : this.displayResult.fields[$name][0]) + "").replace(/<[^>]*>?/gm, '');
            },
            selected(e) {
                this.$emit('input', this.displayResult);
            }
        },
        watch: {
            select(newVal, oldVal) {
                if (newVal) {
                    this.selected();
                }
            }
        },
        computed: {
            thumbnail() {
                if (this.hasThumbnail) {
                    return "/api/service/thumbnail" + this.field('thumbnail');
                }
                return "/siauv4/bootstrap/assets/img/icon_file_" + this.fileFormat.toLowerCase()+".svg";
            },
            hasThumbnail(){
                return this.field('thumbnail');
            },
            fileFormat() {
                if (this.field('mimetype'))
                    return this.field('mimetype').split('/').pop().toUpperCase();
                return "";
            },
            displayResult() {
                let result;
                if (this.result.existing_languages.indexOf(window.locale) >= 0) {
                    if (result = this.result[window.locale])
                        return result;
                }

                if (this.result.existing_languages.indexOf('en') >= 0) {
                    if (result = this.result[window.locale])
                        return result;
                }

                for (let i = 0; i < this.result.existing_languages.length; i++) {
                    let lang = this.result.existing_languages[i];
                    if (this.result[lang]) {

                        if (!!result) {
                            if (this.result[lang].fields.score[0] > result.fields.score[0]) {
                                result = this.result[lang];
                            }

                        } else {
                            result = this.result[lang];
                        }

                    }
                }

                return result;

            }
        }
    }
</script>

<style lang="less" scoped>

    .dropdown-document-result {
        display: flex;

        .result-thumbnail{
            &.no-thumbnail{
                width: 32px;
            }
        }

    }

    .left {
        flex-basis: 20%;
        max-width: 50px;
    }

    .right {
        flex-basis: 80%;
    }

    figure {
        height: 50px;
    }

    figure img {
        max-width: 100%;
        max-height: 100%;
    }

    p {
        color: inherit;
        font-size: 12px;
    }
</style>
